const headerItems = [
  {
    label: 'About',
    slug: 'about',
    href: 'https://rawgraphs.io/about',
  },
  // {
  //   label: 'Gallery',
  //   slug: 'gallery',
  //   href: 'https://rawgraphs.io/gallery',
  // },
  {
    label: 'Learning',
    slug: 'learning',
    href: 'https://rawgraphs.io/learning',
  },
  // {
  //   label: 'FAQs',
  //   slug: 'faqs',
  //   href: 'https://github.com/rawgraphs/raw/wiki/FAQs',
  // },
  // {
  //   label: "RAWGraphs 1.3",
  //   slug: 'rawgraphs-1-3',
  //   href: 'https://app.rawgraphs.io',
  // },
  {
    label: 'GitHub',
    slug: 'github',
    href: 'https://github.com/rawgraphs/rawgraphs-app',
  },
]

export default headerItems
